<img [src]="media.storage === 'ext' ? media.url : stockageUrl + media.url + '?size=' + (size || 1024)" />